/* eslint-disable react/prop-types */
import React from 'react';
// import humanize from 'humanize-string';
// import capitalize from 'utils/capitalize';

const FormatError = ({ error }) => {
  return (
    <>
      {/* {capitalize(humanize(`${name}`))}  */}
      This field {error}
    </>
  );
};

export default FormatError;
